import { styled } from 'styled-components';
import { classic } from '~/themes/classic';
import { useAuth } from '~/helpers/store/auth';
import { useState } from 'react';
import iconDropDown from '@assets/images/icon/dropdown1.svg';
import iconDropDownOpen from '@assets/images/icon/dropdown.svg';
import { Trans } from '@lingui/react';
import iconLogout from '@assets/images/icon/logout-blue.svg';

import useGameStore from '~/helpers/store/game/game';
import { renderFullPath } from '~/utils/common/utils';

type IProps = {
  onClick?: () => void;
};

type TProps = IProps;

export function UserItem({ onClick }: TProps) {
  const { payload } = useAuth();
  const { avatarFileName } = useGameStore();
  const [isOpen, setIsOpen] = useState<boolean>(false);

  function handleOpen() {
    setIsOpen((prev) => !prev);
  }

  return (
    <Wrapper>
      <SDivMenuOpen hidden={!isOpen}>
        <SBtnLogout onClick={onClick}>
          <img src={iconLogout} alt="" />{' '}
          <span>
            <Trans id="common.logout.action" />
          </span>
        </SBtnLogout>
      </SDivMenuOpen>
      <Container onClick={handleOpen}>
        <SDivAvatar>
          {avatarFileName && (
            <img
              key={avatarFileName}
              src={renderFullPath(avatarFileName)}
              alt=""
            />
          )}
        </SDivAvatar>
        <SSpan>{payload?.username}</SSpan>
        {isOpen ? (
          <SIconOpen>
            <img src={iconDropDownOpen} alt="" />
          </SIconOpen>
        ) : (
          <SIconOpen>
            <img src={iconDropDown} alt="" />
          </SIconOpen>
        )}
      </Container>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  position: relative;
`;

const Container = styled.div<{ disabled?: boolean }>`
  align-items: center;
  cursor: pointer;
  border-radius: 52px;
  border: 2px solid #fff;
  background: ${classic.token?.colorWhite || '#fff'};
  box-shadow:
    0px -4px 4px 0px rgba(0, 0, 0, 0.25) inset,
    0px 1px 3px 0px rgba(0, 0, 0, 0.25);
  display: flex;
  font-size: 1.2rem;
  justify-content: center;
  padding: 4px 10px 4px 5px;
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};
  user-select: none;
  position: relative;

  @media screen and (max-width: 450px) {
    padding: 4px 5px;
  }
  @media screen and (max-height: 600px) {
    padding: 4px 5px;
  }
`;

const SBtnLogout = styled.button`
  align-items: center;
  background-color: transparent;
  color: ${classic.token?.colorText};
  font-weight: bold;
  font-size: 1.1rem;
  display: flex;
  justify-content: center;
  height: 60px;
  width: 100%;
  cursor: pointer;
  border: none;
  position: relative;
  img {
    position: absolute;
    top: 50%;
    left: 50%;
    height: 70%;
    object-fit: contain;
    width: 70%;
    transform: translate(-50%, -50%);
    visibility: hidden;
  }

  @media screen and (max-width: 450px) {
    height: 40px;
    font-size: 0.9rem;
    & > span {
      visibility: hidden;
    }
    & > img {
      visibility: visible;
    }
  }
  @media screen and (max-height: 600px) {
    height: 40px;
    font-size: 1rem;
    & > span {
      visibility: hidden;
    }
    & > img {
      visibility: visible;
    }
  }
  @media screen and (max-height: 415px) {
    height: 40px;
    font-size: 0.9rem;
    & > span {
      visibility: hidden;
    }
    & > img {
      visibility: visible;
    }
  }
`;

const SDivMenuOpen = styled.div<{ hidden?: boolean }>`
  border-radius: 0 0 16px 16px;
  position: absolute;
  top: 50%;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  background-color: #fff;
  overflow: hidden;

  height: ${({ hidden }) => (hidden ? '0' : '90px')};
  transition: ${({ hidden }) => (hidden ? 'none' : 'opacity 0.5s linear')};
  opacity: ${({ hidden }) => (hidden ? '0' : '1')};
  visibility: ${({ hidden }) => (hidden ? 'hidden' : 'visible')};
  width: ${({ hidden }) => (hidden ? '0' : '100%')};

  @media screen and (max-width: 450px) {
    height: ${({ hidden }) => (hidden ? '0' : '65px')};
  }
  @media screen and (max-height: 600px) {
    height: ${({ hidden }) => (hidden ? '0' : '65px')};
  }
`;
const SIconOpen = styled.div`
  height: 32px;
  width: 32px;
  position: relative;
  img {
    left: 0;
    top: 0;
    height: 100%;
    object-fit: contain;
    width: 100%;
    position: absolute;
  }
`;

const SSpan = styled.span`
  color: ${classic.token?.colorFillSecondary || '#EA7A49'};
  visibility: visible;
  font-family: 'Riffic Free', sans-serif;
  height: auto;
  width: auto;
  margin-left: 5px;

  @media screen and (max-width: 450px) {
    visibility: hidden;
    height: 0;
    width: 0;
    margin-left: 0;
  }
  @media screen and (max-height: 600px) {
    visibility: hidden;
    height: 0;
    width: 0;
    margin-left: 0;
  }
`;

const SDivAvatar = styled.div`
  border-radius: 50%;
  background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0.2) 0%,
      rgba(0, 0, 0, 0) 100%
    ),
    #fff;
  height: 50px;
  width: 50px;
  position: relative;
  img {
    left: 0;
    top: 0;
    height: 100%;
    object-fit: contain;
    width: 100%;
    position: absolute;
  }
  @media screen and (max-width: 450px) {
    width: 35px;
    height: 35px;
  }
  @media screen and (max-height: 800px) {
    width: 35px;
    height: 35px;
  }
`;

// classic.token?.colorPrimary
/*
@media screen and (max-width: 300px) {
    @media screen and (max-width: 450px) {
    padding: calc(0.5rem + 6px) 5px 10px 5px;
  }
  @media screen and (min-height: 800px) {
    padding: calc(0.7rem + 10px) 24px;
  }
  }
*/
